import Vue from 'vue'
import { Button, Tabs, TabPane, Upload, Dialog, Input, Select, Option, Progress, Alert, Message, Form, FormItem, Link, Collapse, CollapseItem } from 'element-ui'

Vue.use(Button)
Vue.use(Input)
Vue.use(Select);
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Option)
Vue.use(Progress)
Vue.use(Alert)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Link)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.component(Message.name, Message)
Vue.prototype.$message = Message
